module.exports = __webpack_public_path__ + "main/assets/public/search-box/magnifying-glass.d7b55c697db740cc.svg";